import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter } from 'events';

export enum checkboxStatusEnum {
    UNCHECKED,
    CHECKED,
    INDETERMINATE
}

@Component({

    selector: 'syn-menu-checkbox',
    templateUrl: 'menu-checkbox.component.html',
    styleUrls: ['menu-checkbox.component.scss']
})
export class MenuCheckboxComponent implements OnInit {

    @Input() label = '';
    @Input() status = checkboxStatusEnum.UNCHECKED;
    @Input() disabled = false;
    @Input() height = 48;
    @Input() overrideStatus: EventEmitter;

    public icon = 'check_box_outline_blank';
    public className = 'checkbox--unchecked';

    public ngOnInit(): void {
        this.switchStatus(this.status);
        if (this.overrideStatus) {
            this.overrideStatus.addListener('setStatus', (status) => this.switchStatus(status));
        }
    }

    public switchStatus(status) {
        if (status === checkboxStatusEnum.CHECKED) {
            this.status = checkboxStatusEnum.CHECKED;
            this.icon = 'checkbox-marked-outline';
            this.className = 'checkbox--checked';
        } else if (status === checkboxStatusEnum.INDETERMINATE) {
            this.status = checkboxStatusEnum.INDETERMINATE;
            this.icon = 'minus-box-outline';
            this.className = 'checkbox--indeterminate';
        } else {
            this.status = checkboxStatusEnum.UNCHECKED;
            this.icon = 'checkbox-blank-outline';
            this.className = 'checkbox--unchecked';
        }
    }

    public onClick() {
        if (this.overrideStatus) {
            return;
        }
        if (this.status === checkboxStatusEnum.UNCHECKED) {
            this.switchStatus(checkboxStatusEnum.CHECKED);
        } else {
            this.switchStatus(checkboxStatusEnum.UNCHECKED);
        }
    }

}
